import React from "react";
import "./LaunchingSoon.css";
import logo from "../../assets/logo.svg"; // Adjust path to your logo

const LaunchingSoon = () => {
    return (
        <div className="launching-container">
            <div className="overlay"></div>

            {/* Logo at Top Right */}
            <div className="logo-container">
                <img src={logo} alt="Logo" className="logo" />
            </div>

            {/* Restaurant Name at Top */}
            <div className="header">
                <h1 className="title">Touch My Food</h1>
            </div>

            {/* Remaining Content at Bottom */}
            <div className="bottom-content">
                <h2 className="subtitle">Launching Soon in Changanassery</h2>
                <p className="text">
                    We’re cooking up something special! Stay tuned for our grand opening.
                </p>
            </div>
        </div>
    );
};

export default LaunchingSoon;
